import React from 'react';
import PropTypes from 'prop-types';
import Card from '@welldev-group/rcl-card';
import ClassNames from 'classnames';

const GenericInfoCard = ({ value, unit, info }) => (
  <Card version="v2">
    <div className="generic-info-card">
      <div className="generic-info-card__quantity">
        <div
          className={ClassNames('generic-info-card__value', {
            'generic-info-card__value--disabled': value === 0 || value === '0',
          })}
        >
          {value}
        </div>
        <div className="generic-info-card__unit">{unit}</div>
      </div>
      <div className="generic-info-card__info">{info}</div>
    </div>
  </Card>
);

GenericInfoCard.defaultProps = {
  unit: null,
};

GenericInfoCard.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  unit: PropTypes.node,
  info: PropTypes.node.isRequired,
};

export default GenericInfoCard;
